<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <ValidationObserver ref="observer">
      <div class="mt-5 vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-5">
            <li>
              <router-link to="/manageCodesList" class="vx-row">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                <h4>{{ $t("system.label.AddCode") }}</h4>
              </router-link>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('system.label.CodeName')"
              >
                <vs-input
                  v-model="name"
                  :label="$t('system.label.CodeName')"
                  class="w-full mb-5 font-semibold starlabel"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("system.label.Module") }}
                  <span class="required">*</span>
                </small>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.Module')"
                >
                  <v-select
                    label="item"
                    v-model="module"
                    :options="selectorModule"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.item
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("system.label.Description")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.Description')"
                >
                  <vs-textarea v-model="description" />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("system.label.reset") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="createAddCode"
            >{{ $t("system.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  data() {
    return {
      breadcrumbs: [
        { name: this.$t("reports.label.configurations"), to: "/config" },
        {
          name: this.$t("system.label.AddCode"),
          to: "/",
        },
      ],
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      name: "",
      description: "",
      module: "",
      selectorModule: ["Client", "Ticketing", "Master", "Order", "Scheduler"],
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {},
  methods: {
    async createAddCode() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        let payload = {
          name: this.name,
          module: this.module,
          description: this.description,
        };
        await this.$store.dispatch("manageCodes/createcodesAction", payload);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Manage Codes Created Successfully!",
          type: "success",
        });
        this.$router.push("/manageCodesList");
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    resetForm() {
      this.name = "";
      this.description = "";
      this.module = "";
      // Clear validation errors
      this.$refs.observer.reset();
    },
  },

  mounted() {},
};
</script>
